module.exports = __webpack_public_path__ + "omniv2/img/icon-apple-store.d0558d91.svg";